import { useGlobalState } from '@/store/commonStore';
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';


export default function Private({ children }: any) {
    const { isLogin } = useGlobalState();
    const navigate = useNavigate();
    useEffect(()=>{
        if(!isLogin) {
            navigate('/home',{replace: true});
        }
    },[isLogin])
    return <>
          {isLogin && children}
    </>
}